module.exports = __webpack_public_path__ + "static/media/instagram.cf717e2c.svg";